module.exports = __webpack_public_path__ + "static/img/gywm_tu1.bf33082.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/gywm_tu1.png
// module id = TXNb
// module chunks = 1